const reqsTypes = {
  SET_REQS_TAB: "SET_REQS_TAB",
  SET_ALLREQS_PAGE: "SET_ALLREQS_PAGE",
  SET_MYREQS_PAGE: "SET_MYREQS_PAGE",

  FETCH_MYREQS_START: "FETCH_MYREQS_START",
  FETCH_MYREQS_SUCCESS: "FETCH_MYREQS_SUCCESS",

  FETCH_ALLREQS_START: "FETCH_ALLREQS_START",
  FETCH_ALLREQS_SUCCESS: "FETCH_ALLREQS_SUCCESS",
};

export default reqsTypes;
